/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');
var UIUtil = require('psa-core/util/ui');

var GridView = require('psa-marionette/views/GridView');
var PageableCollection = require('psa-backbone/models/PageableCollection');

var SecInternalSidebarNavView = require('./SecInternalSidebarNavView');

require('../styles/SecComplianceRegistrationSearchView.css');
var tmplSecComplianceRegistrationSearchView = require('../templates/SecComplianceRegistrationSearchView.hbs');
var IconBooleanCell = require('common/backgrid/IconBooleanCell');
var MultiButtonCell = require('common/backgrid/MultiButtonCell');
var SubmitUserComplianceRegistration = require('../../compliance-registration-form/services/SubmitUserComplianceRegistration');
var ConfirmationModalView = require('common/views/ConfirmationModalView');

module.exports = Marionette.LayoutView.extend({
  template: tmplSecComplianceRegistrationSearchView,

  className: 'sec-compliance-registration-search-view container-fluid',

  ui: {
    sideBar: '.side-bar-container',
    searchSummary: '.search-summary',
    searchResultsContainer: '.search-results-container',
    search: '.search',
    searchType: 'select[name="objectType"]',
    orgFilters: '.org-filter',
    indFilters: '.ind-filter',
    clearFilters: '.clear-filters',
    formInputs: ':input'
  },

  regions: {
    sideBar: '@ui.sideBar',
    searchResultsContainer: '@ui.searchResultsContainer',
    searchSummary: '@ui.searchSummary'
  },

  events: {
    'click @ui.search': 'onClickSearch',
    'change @ui.searchType': 'onChangeSearchType',
    'click @ui.clearFilters': 'onClickClearFilters',
    'keydown @ui.formInputs': 'onKeydownOfInputs'
  },

  onBeforeShow: function() {
    this.showChildView('sideBar', new SecInternalSidebarNavView());
    this.collection = new PageableCollection(this.model.get('complianceRegistrations'), { pageSize: 25 });
    this.shadowCollection = new PageableCollection([], { pageSize: 25 });

    this.shadowCollection.fullCollection.reset(this.collection.fullCollection.models);
    this.searchResults = new GridView({
      columns: [
        {
          name: 'firstName',
          label: 'First Name',
          cell: 'string',
          width: '20%',
          editable: false
        },
        {
          name: 'lastName',
          label: 'Last Name',
          cell: 'string',
          headerCell: 'custom',
          width: '20%',
          editable: false
        },
        {
          name: 'professionalType',
          label: 'Professional Type',
          cell: 'string',
          headerCell: 'custom',
          width: '20%',
          editable: false
        },
        {
          name: 'organization',
          label: 'Organization',
          cell: 'string',
          headerCell: 'custom',
          width: '20%',
          editable: false
        },
        {
          name: 'year',
          label: 'Year',
          cell: 'string',
          headerCell: 'custom',
          width: '8%',
          editable: false
        },
        {
          name: 'isInternalRegistration',
          label: 'Internal',
          cell: IconBooleanCell.extend({
            name: 'isInternalRegistration',
            iconClass: 'fa fa-flag fa-lg',
            iconStyle: 'color:black'
          }),
          headerCell: 'custom',
          width: '5%',
          editable: false
        },
        {
          name: '',
          label: '',
          cell: MultiButtonCell.extend({
            buttons: [
              {
                name: '',
                newTab: true,
                labelClass: 'fa fa-eye',
                buttonClass: 'btn-primary btn-sm',
                href: function(model) {
                  var id = model.get('userComplianceRegistrationId');
                  return '#sec/compreg/' + id + '/view';
                }
              },
              {
                name: '',
                labelClass: 'fa fa-edit',
                buttonClass: 'btn-primary btn-sm',
                href: function(model) {
                  var id = model.get('userComplianceRegistrationId');
                  return '#sec/compreg/' + id + '/edit';
                }
              },
              {
                name: '',
                labelClass: 'fa fa-trash',
                buttonClass: 'btn-danger btn-sm',
                onClick: this.onClickDeleteComplianceRegistration.bind(this)
              }
            ]
          }),
          headerCell: 'custom',
          width: '8%',
          sortable: false,
          editable: false
        }
      ],
      collection: this.shadowCollection,
      emptyText: 'No Compliance Registrations Found'
    });

    this.showChildView('searchResultsContainer', this.searchResults);

    this.searchResults.getViewGrid().sort('year', 'descending');

    this.$('.backgrid.table').addClass('table-bordered');
  },

  onKeydownOfInputs: function(e) {
    // Searches on press of enter
    if (e.keyCode === 13) {
      this.onClickSearch(e);
    }
  },

  onClickSearch: function(e) {
    e.preventDefault();
    var self = this;
    var filter = Syphon.serialize(this, {
      inputReaders: Syphon.SearchInputReaderSet
    });
    filter = _.pick(filter, _.identity);
    this.shadowCollection.fullCollection.reset(this.collection.fullCollection.models);
    var models;

    _.each(filter, function(filterVal, filterType, filter) {
      models = self.shadowCollection.fullCollection.filter(function(model) {
        return self.filter(model, filterType, filterVal);
      });
      self.shadowCollection.fullCollection.reset(models);
    });
  },

  filter: function(shadow, filterType, filterVal) {
    var temp = isNaN(shadow.attributes[filterType])
      ? shadow.attributes[filterType].toLowerCase()
      : shadow.attributes[filterType];
    filterVal = isNaN(filterVal) ? filterVal.toLowerCase() : filterVal;
    return typeof temp === 'string' && temp.indexOf(filterVal) > -1;
  },

  onClickClearFilters: function() {
    this.ui.formInputs.val('');
  },

  onClickDeleteComplianceRegistration: function(e, model) {
    e.preventDefault();
    var self = this;
    var message = 'Are you sure you want to delete this compliance registration?';
    UIUtil.showModal({
      title: 'Confirm Compliance Registration Removal',
      view: new ConfirmationModalView({
        confirmText: 'Remove Compliance Registration',
        model: new Backbone.Model({
          message: message,
          onConfirm: function() {
            var formData = {};
            formData.complianceRegistrationId = model.get('userComplianceRegistrationId');
            formData.isDeleted = 1;
            return SubmitUserComplianceRegistration(formData).done(function() {
              self.collection.fullCollection.remove(model);
              self.shadowCollection.remove(model);
            });
          }
        })
      })
    });
  }
});
